import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, tap } from 'rxjs';
import { Person } from '../../models/person.model';
import { PersonService } from '../../services/person.service';

@Injectable()
export class PersonEventsContextService {
  private personSubject = new BehaviorSubject<Person | null>(null);
  private currentPersonId = '';

  readonly person$ = this.personSubject.asObservable();

  constructor(private readonly personService: PersonService) {}

  get personId(): string {
    return this.currentPersonId;
  }

  get person(): Person | null {
    return this.personSubject.value;
  }

  initialize(personId: string): Observable<Person> {
    this.currentPersonId = personId;
    return this.refreshPerson();
  }

  refreshPerson(): Observable<Person> {
    return this.personService.getPerson(this.currentPersonId).pipe(
      tap(person => this.personSubject.next(person)),
    );
  }
}
